import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IClassesParams, IClassesResponse, IClassesState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchListClasses = createAsyncThunk(
  'listClasses/fetchListClasses',
  async ({ query }: IClassesParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.getClasses(query)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IClassesState = {
  isLoading: false,
  response: null,
  error: null
}

const listClassSlice = createSlice({
  name: 'classes/list',
  initialState,
  reducers: {
    resetListClasses: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchListClasses.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchListClasses.fulfilled, (state, action: PayloadAction<IClassesResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchListClasses.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default listClassSlice.reducer
export const { resetListClasses } = listClassSlice.actions
